/**
 * Expert badge — a small ◎ chip next to a person's name showing they can
 * train others, with the skill list in the tooltip.
 *
 * The expert map is fetched once and shared by every badge on the page.
 */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../../lib/api';

let cache = null;
let inflight = null;

export const loadExperts = (headers) => {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = axios.get(`${API}/skills/badges`, { headers })
      .then(({ data }) => { cache = data.experts || {}; return cache; })
      .catch(() => { cache = {}; return cache; })
      .finally(() => { inflight = null; });
  }
  return inflight;
};

export const invalidateExperts = () => { cache = null; };

export const SkillBadge = ({ staffId, authHeader, showCount = true, className = '' }) => {
  const [experts, setExperts] = useState(cache);

  useEffect(() => {
    let alive = true;
    loadExperts(authHeader ? authHeader() : undefined).then((e) => { if (alive) setExperts(e); });
    return () => { alive = false; };
  }, [authHeader]);

  const info = experts?.[staffId];
  if (!info || !info.skills?.length) return null;

  return (
    <span
      title={`Can train others in: ${info.skills.join(', ')}`}
      data-testid={`skill-badge-${staffId}`}
      className={`inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full bg-emerald-600 text-white text-[10px] font-semibold align-middle ${className}`}
    >
      ◎{showCount ? ` ${info.skills.length}` : ''}
    </span>
  );
};

export default SkillBadge;
